import { render, staticRenderFns } from "./LoyaltyGift.vue?vue&type=template&id=e8e0611c"
import script from "./LoyaltyGift.vue?vue&type=script&lang=js"
export * from "./LoyaltyGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports